import { Component } from '@angular/core';
import { AnnouncementService } from 'src/app/services/announcement.service';
import { LaunchService } from 'src/app/services/launchpad.service';
import { environment } from 'src/environments/environment';
interface QueryParams {
    fillter: string,
    sortObj: string,
    page: number,
    limit: number
}
@Component({
  selector: 'app-trading-contest',
  templateUrl: './trading-contest.component.html',
  styleUrls: ['./trading-contest.component.css']
})

export class TradingContestComponent {


  imageUrls: string[] = [];


  pageSize = 10;
  currentPage = 0;
  pageSizeOptions: number[] = [10, 25, 50, 100];
  queryParams: QueryParams = {
    fillter: '{}',
    sortObj: '{}',
    page: this.currentPage + 1,
    limit: this.pageSize
  };

 
  ngOnInit() {
    // Simulating backend API response
    this.fetchImages();
    this.getLaunchPad(); 
  }

fetchImages(): void {
  this.service.getAllOffers(this.queryParams).subscribe({
    next: (res: any) => {
      const baseUrl = environment.userApiUrl + '/slider/';

      this.imageUrls = res.result?.data
        .filter((img: any) => img.status === 'active' && img.modelName === 'trade-contest')
        .map((img: any) => baseUrl + img.image);
    },
    error: () => {
      this.imageUrls = [];
    }
  });
}

  data: any = 'upcoming';
  launchData: any = [];
  constructor(private LaunchService: LaunchService,
    private service: AnnouncementService,
) {}
  onInputChange(event: Event) { 
    const eventData = (event.target as HTMLInputElement).name;
    this.data = eventData;
    this.getLaunchPad();
  }


  getLaunchPad() {
    // this.LaunchService.getLaunchData(this.data).subscribe({
    //   next: (v: any) => {
    //     if (v.success) {
    //       this.launchData = v.result.data;
    //     }
    //   },
    //   error: (err) => {},
    // });
  }
}
